import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=0e0e65fc&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=0e0e65fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e65fc",
  null
  
)

export default component.exports